import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-callout',
  templateUrl: './callout.component.html',
  styleUrls: ['./callout.component.scss']
})
export class CalloutComponent implements OnInit, OnChanges {
  @Input() i18nkey = 'my-callout';
  @Input() faIcon;
  @Input() style: 'DEFAULT' | 'LIGHTBLUE' = 'DEFAULT'
  @Input() iconColor = ''
  isDefault = false
  isLightblue = false

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.style) {
      this.isDefault = this.style === 'DEFAULT';
      this.isLightblue = this.style === 'LIGHTBLUE';
    }
  }

  ngOnInit(): void {
  }

}
